export default {
  tipLeastNeededColumns: '最少需要展示2列',
  tipLeastColumns: '最少展示2列',
  customColumn: '自定义列',
  showColumn: '展示此列',
  stickColumn: '固定此列',
  showAll: '全部展示',
  noData: '没有数据',
  restoreDefault: '恢复默认',
  notice: '提示',
  ok: '确定',
  detail: '详情',
  cancel: '取消',
  submit: '提交',
  totalCount: '总计',
  collapse: '收起',
  expand: '展开',
  more: '更多'
};